/* eslint-disable */

const init = () => {
	const chatCircleArr = document.querySelectorAll('.js-chat-circle');
	if (chatCircleArr) {
		chatCircleArr.forEach(chatCircle => {
			const innerCircles = chatCircle.querySelectorAll('.chart-circle__graph');
			innerCircles.forEach(circle => {
				const scaleValue = Math.round(Math.sqrt(parseFloat(circle.getAttribute('data-circle-scale'), 10)) * 100);
				circle.style.transform = `scale3d(${scaleValue}%, ${scaleValue}%, 1)`;

				// To mitigate scaling of it's parent element
				const circleText = circle.querySelector('.chart-circle__graph-text') || null;
				if (circleText !== null) {
					circleText.style.transform = `translate(-50%, -50%) scale3d(${1 / (scaleValue / 100)}, ${1 / (scaleValue / 100)}, 1)`;
				}
			});
		});
	}
};

export default {
	init,
};
/* eslint-enable */
